module.exports = __webpack_public_path__ + "static/media/card_bg_1.8da42125.png";